import React from 'react';
import { DNAChip, HelpCircleTooltip } from 'src/components/DNA';

type ExtensionBadgeProps = {
  extension: string;
};

const validVideoExtensions = ['MP4', 'MOV', 'AVI', 'WMV', 'FLV', 'MKV', 'WEBM', 'MPEG'];
const supportedExtensions = ['PPTX', 'PDF', 'VIDEO', 'ZIP', 'HTML'];

const ExtensionBadge: React.FC<ExtensionBadgeProps> = (props) => {
  const extension = validVideoExtensions.includes(props.extension.toUpperCase())
    ? 'VIDEO'
    : props.extension.toUpperCase();
  const isSupportedExtension = supportedExtensions.includes(extension);

  if (isSupportedExtension) {
    return (<DNAChip.Beacon testID="preview-modal-file-type" children={extension} />)
  } else {
    return (<HelpCircleTooltip popoverText="File type is not supported" />)
  }
}

export default ExtensionBadge;
